(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-collection-bundles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-collection-bundle-rail')) {
    customElements.define('gf-collection-bundle-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bundle-track]');
        this.cards = Array.from(this.querySelectorAll('.gf-collection-bundles__card'));
        this.dots = Array.from(this.querySelectorAll('[data-bundle-dot]'));
        if (!this.track || this.cards.length < 2 || this.dots.length !== this.cards.length) return;

        this.updatePagination = () => {
          let activeIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;
          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.offsetLeft - this.track.scrollLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              activeIndex = index;
            }
          });
          this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
        };

        this.track.addEventListener('scroll', this.updatePagination, { passive: true });
        this.updatePagination();
      }

      disconnectedCallback() {
        if (this.track && this.updatePagination) this.track.removeEventListener('scroll', this.updatePagination);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-collection-marquee"] && !Shopify.designMode) return;
  try {
    
  class GFCollectionMarquee extends HTMLElement {
    connectedCallback() {
      this.group = this.querySelector('[data-marquee-group]');
      this.speed = Number(this.dataset.speed) || 70;
      this.updateDuration = this.updateDuration.bind(this);
      this.resizeObserver = new ResizeObserver(this.updateDuration);

      if (this.group) {
        this.resizeObserver.observe(this.group);
        this.updateDuration();
      }

      if (document.fonts) {
        document.fonts.ready.then(this.updateDuration);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    updateDuration() {
      if (!this.group) return;

      const duration = Math.max(this.group.scrollWidth / this.speed, 8);
      this.style.setProperty('--gf-marquee-duration', `${duration}s`);
    }
  }

  if (!customElements.get('gf-collection-marquee')) {
    customElements.define('gf-collection-marquee', GFCollectionMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-happy-customers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-happy-review-rail')) {
    customElements.define('gf-happy-review-rail', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-review-track]');
        const previous = this.querySelector('[data-review-previous]');
        const next = this.querySelector('[data-review-next]');
        if (!track || !previous || !next) return;
        const move = (direction) => {
          const card = track.querySelector('.gf-happy-customers__card');
          track.scrollBy({ left: direction * (card?.getBoundingClientRect().width || track.clientWidth) * .95, behavior: 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-help-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-help-center')) {
    customElements.define('gf-help-center', class extends HTMLElement {
      connectedCallback() {
        this.searchInput = this.querySelector('[data-gf-faq-search-input]');
        this.clearButton = this.querySelector('[data-gf-faq-search-clear]');
        this.searchStatus = this.querySelector('[data-gf-faq-search-status]');
        this.searchShell = this.searchInput?.closest('.gf-help__search');
        this.items = Array.from(this.querySelectorAll('[data-gf-faq-item]'));
        this.groups = Array.from(this.querySelectorAll('.gf-help__group'));
        this.topicLinks = Array.from(this.querySelectorAll('.gf-help__topics a'));
        this.searchTimer = 0;
        this.handleHashChange = () => this.openLinkedQuestion();

        this.searchInput?.addEventListener('input', () => this.updateSearch());
        this.clearButton?.addEventListener('click', () => this.clearSearch());
        this.items.forEach((item) => item.addEventListener('toggle', () => {
          if (item.open) this.track('faq_open', { question: item.querySelector('summary')?.innerText.trim() || '', question_id: item.id });
        }));
        this.querySelectorAll('.gf-help__answer a, .gf-help__footer-card a, .gf-help__contact-card a').forEach((link) => {
          link.addEventListener('click', () => this.track('faq_link_click', { label: link.innerText.trim(), destination: link.getAttribute('href') || '' }));
        });
        window.addEventListener('hashchange', this.handleHashChange);
        this.openLinkedQuestion();
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.handleHashChange);
        window.clearTimeout(this.searchTimer);
      }

      normalize(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      }

      updateSearch() {
        const query = this.normalize(this.searchInput?.value || '');
        let visibleCount = 0;

        this.items.forEach((item) => {
          const matches = !query || this.normalize(item.innerText).includes(query);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        this.groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-gf-faq-item]:not([hidden])');
        });
        this.topicLinks.forEach((link) => {
          const group = this.querySelector(link.getAttribute('href'));
          link.hidden = Boolean(group?.hidden);
        });

        if (this.clearButton) this.clearButton.hidden = !query;
        if (this.searchStatus) {
          if (!query) {
            this.searchStatus.textContent = '';
          } else if (visibleCount === 0) {
            this.searchStatus.textContent = this.searchShell?.dataset.searchNoResults || '';
          } else if (visibleCount === 1) {
            this.searchStatus.textContent = this.searchShell?.dataset.searchResultOne || '';
          } else {
            this.searchStatus.textContent = `${visibleCount} ${this.searchShell?.dataset.searchResultMany || ''}`;
          }
        }

        window.clearTimeout(this.searchTimer);
        if (query) {
          this.searchTimer = window.setTimeout(() => this.track('faq_search', { query, result_count: visibleCount }), 700);
        }
      }

      clearSearch() {
        if (!this.searchInput) return;
        this.searchInput.value = '';
        this.updateSearch();
        this.searchInput.focus();
        this.track('faq_search_clear', {});
      }

      openLinkedQuestion() {
        if (!window.location.hash) return;
        const target = document.getElementById(window.location.hash.slice(1));
        if (!(target instanceof HTMLDetailsElement) || !this.contains(target)) return;

        this.items.forEach((item) => item.classList.remove('gf-help__item--linked'));
        target.open = true;
        target.classList.add('gf-help__item--linked');
        window.requestAnimationFrame(() => target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
      }

      track(action, detail) {
        const payload = { action, ...detail };
        this.dispatchEvent(new CustomEvent('gf:faq-interaction', { bubbles: true, detail: payload }));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'gf_faq_interaction', ...payload });
        try {
          window.Shopify?.analytics?.publish?.('gf_faq_interaction', payload);
        } catch (error) {
          return;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-home-bundles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-bundle-rail')) {
    customElements.define('gf-bundle-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bundle-track]');
        this.cards = Array.from(this.querySelectorAll('.gf-home-bundles__card'));
        this.dots = Array.from(this.querySelectorAll('[data-bundle-dot]'));
        if (!this.track || this.cards.length < 2 || this.dots.length !== this.cards.length) return;
        this.updatePagination = () => {
          let activeIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;
          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.offsetLeft - this.track.scrollLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              activeIndex = index;
            }
          });
          this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
        };
        this.track.addEventListener('scroll', this.updatePagination, { passive: true });
        this.updatePagination();
      }

      disconnectedCallback() {
        if (this.track && this.updatePagination) this.track.removeEventListener('scroll', this.updatePagination);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-home-hero-occasion-saved"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-occasion-hero')) {
    class GfOccasionHero extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.committedIndex = Number(this.dataset.defaultIndex || 1);
        this.tablist = this.querySelector('[role="tablist"]');
        this.primaryAction = this.querySelector('[data-primary-action]');
        this.autoplayEnabled = this.dataset.autoplay === 'true' && !(window.Shopify && window.Shopify.designMode);
        this.autoplayDelay = Math.max(Number(this.dataset.autoplayDelay) || 4000, 3000);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayTimer = null;

        this.pauseAutoplay = () => this.stopAutoplay();
        this.resumeAfterFocus = () => {
          window.setTimeout(() => {
            if (!this.contains(document.activeElement)) this.startAutoplay();
          }, 0);
        };
        this.handleVisibility = () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        };

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.committedIndex = index + 1;
            this.show(this.committedIndex, true);
            this.restartAutoplay();
          });
          tab.addEventListener('mouseenter', () => {
            this.committedIndex = index + 1;
            this.show(this.committedIndex, false);
            this.restartAutoplay();
          });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.panels.forEach((panel) => this.monitorImage(panel));
        this.addEventListener('focusin', this.pauseAutoplay);
        this.addEventListener('focusout', this.resumeAfterFocus);
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.preloadNextPanel();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.removeEventListener('focusin', this.pauseAutoplay);
        this.removeEventListener('focusout', this.resumeAfterFocus);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      monitorImage(panel) {
        const picture = panel?.querySelector('.gf-home-hero__picture');
        const image = picture?.querySelector('img');
        if (!picture || !image || image.dataset.gfMonitored === 'true') return;

        image.dataset.gfMonitored = 'true';
        const revealImage = () => {
          picture.classList.remove('is-loading', 'is-error');
        };
        const showFallback = () => {
          picture.classList.remove('is-loading');
          picture.classList.add('is-error');
        };

        image.addEventListener('load', revealImage);
        image.addEventListener('error', showFallback);
        if (image.complete && image.naturalWidth > 0) revealImage();
      }

      loadPanelImage(panel) {
        if (!panel) return;
        const picture = panel.querySelector('.gf-home-hero__picture');
        const image = picture?.querySelector('img');
        if (!picture || !image) return;

        this.monitorImage(panel);
        picture.classList.add('is-loading');
        picture.querySelectorAll('source[data-srcset]').forEach((source) => {
          source.srcset = source.dataset.srcset;
          delete source.dataset.srcset;
        });
        if (image.dataset.src) {
          image.src = image.dataset.src;
          delete image.dataset.src;
        }
        if (image.complete && image.naturalWidth > 0) picture.classList.remove('is-loading', 'is-error');
      }

      nextIndex() {
        if (!this.tabs.length) return 1;
        return (this.committedIndex % this.tabs.length) + 1;
      }

      preloadNextPanel() {
        const nextPanel = this.panels.find((panel) => Number(panel.dataset.occasionIndex) === this.nextIndex());
        this.loadPanelImage(nextPanel);
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.autoplayEnabled || this.tabs.length < 2 || this.reducedMotion.matches || document.hidden) return;
        if (this.contains(document.activeElement)) return;

        this.autoplayTimer = window.setTimeout(() => {
          this.committedIndex = this.nextIndex();
          this.show(this.committedIndex, false);
          this.preloadNextPanel();
          this.startAutoplay();
        }, this.autoplayDelay);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      show(index, commitFocus) {
        const nextPanel = this.panels.find((panel) => Number(panel.dataset.occasionIndex) === index);
        const nextTab = this.tabs.find((tab) => Number(tab.dataset.occasionIndex) === index);
        if (!nextPanel) return;

        this.loadPanelImage(nextPanel);

        this.tabs.forEach((tab) => {
          const isActive = Number(tab.dataset.occasionIndex) === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel === nextPanel;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
          panel.toggleAttribute('inert', !isActive);
        });

        if (this.primaryAction && nextTab) {
          if (nextTab.dataset.ctaLabel) this.primaryAction.textContent = nextTab.dataset.ctaLabel;
          if (nextTab.dataset.ctaLink) this.primaryAction.href = nextTab.dataset.ctaLink;
        }

        this.closest('.gf-home-hero-shell')?.style.setProperty('--gf-occasion-current-accent', nextPanel.dataset.accent);
        if (commitFocus) this.tabs[index - 1]?.focus({ preventScroll: true });
      }

      onKeydown(event, currentIndex) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        this.committedIndex = nextIndex + 1;
        this.show(this.committedIndex, true);
        this.restartAutoplay();
      }
    }

    customElements.define('gf-occasion-hero', GfOccasionHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-occasion-hero')) {
    class GfOccasionHero extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.committedIndex = Number(this.dataset.defaultIndex || 1);
        this.autoRotate = this.dataset.autoRotate === 'true';
        this.rotationDelay = Number(this.dataset.rotationSeconds || 5) * 1000;
        this.pointerPaused = false;
        this.focusPaused = false;
        this.tablist = this.querySelector('[role="tablist"]');
        this.handleVisibilityChange = () => {
          if (document.hidden) {
            this.stopAutoRotate();
          } else {
            this.startAutoRotate();
          }
        };

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('pointerenter', () => this.show(index + 1, false));
          tab.addEventListener('focus', () => this.show(index + 1, false));
          tab.addEventListener('click', () => {
            this.committedIndex = index + 1;
            this.show(this.committedIndex, true);
            this.restartAutoRotate();
          });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.tablist?.addEventListener('pointerleave', () => this.show(this.committedIndex, false));
        this.addEventListener('pointerenter', () => {
          this.pointerPaused = true;
          this.stopAutoRotate();
        });
        this.addEventListener('pointerleave', () => {
          this.pointerPaused = false;
          this.startAutoRotate();
        });
        this.addEventListener('focusin', () => {
          this.focusPaused = true;
          this.stopAutoRotate();
        });
        this.addEventListener('focusout', (event) => {
          if (this.contains(event.relatedTarget)) return;
          this.focusPaused = false;
          this.startAutoRotate();
        });
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.startAutoRotate();
      }

      disconnectedCallback() {
        this.stopAutoRotate();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }

      startAutoRotate() {
        this.stopAutoRotate();
        if (!this.autoRotate || this.tabs.length < 2 || this.pointerPaused || this.focusPaused || document.hidden) return;

        this.rotationTimer = window.setTimeout(() => {
          this.committedIndex = (this.committedIndex % this.tabs.length) + 1;
          this.show(this.committedIndex, false);
          this.startAutoRotate();
        }, this.rotationDelay);
      }

      stopAutoRotate() {
        window.clearTimeout(this.rotationTimer);
      }

      restartAutoRotate() {
        this.stopAutoRotate();
        this.startAutoRotate();
      }

      show(index, commitFocus) {
        const nextPanel = this.panels.find((panel) => Number(panel.dataset.occasionIndex) === index);
        if (!nextPanel) return;

        this.tabs.forEach((tab) => {
          const isActive = Number(tab.dataset.occasionIndex) === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel === nextPanel;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
          panel.toggleAttribute('inert', !isActive);
        });

        this.closest('.gf-home-hero-shell')?.style.setProperty('--gf-occasion-current-accent', nextPanel.dataset.accent);
        if (commitFocus) this.tabs[index - 1]?.focus({ preventScroll: true });
      }

      onKeydown(event, currentIndex) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        this.committedIndex = nextIndex + 1;
        this.show(this.committedIndex, true);
        this.restartAutoRotate();
      }
    }

    customElements.define('gf-occasion-hero', GfOccasionHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-review-rail')) {
    customElements.define('gf-review-rail', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-review-track]');
        const previous = this.querySelector('[data-review-previous]');
        const next = this.querySelector('[data-review-next]');
        if (!track || !previous || !next) return;
        const move = (direction) => {
          const card = track.querySelector('.gf-home-reviews__card');
          track.scrollBy({ left: direction * (card?.getBoundingClientRect().width || track.clientWidth) * 0.9, behavior: 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-home-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-video-hero')) {
    class GfVideoHero extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[aria-pressed]');
        this.videos = Array.from(this.querySelectorAll('video'));
        this.button?.addEventListener('click', () => this.togglePlayback());
      }

      togglePlayback() {
        const shouldPause = this.button.getAttribute('aria-pressed') === 'false';
        this.videos.forEach((video) => {
          if (shouldPause) video.pause();
          if (!shouldPause) video.play().catch(() => {});
        });
        this.button.setAttribute('aria-pressed', String(shouldPause));
        this.button.setAttribute('aria-label', shouldPause ? this.dataset.pausedLabel : this.dataset.playingLabel);
      }
    }

    customElements.define('gf-video-hero', GfVideoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-password"] && !Shopify.designMode) return;
  try {
    
  class GfPasswordCursorDog extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.frames = {
        neutral: 0,
        'cross-eyed': 7.692308,
        left: 15.384615,
        right: 23.076923,
        up: 30.769231,
        down: 38.461538,
        'upper-left': 46.153846,
        'upper-right': 53.846154,
        'lower-left': 61.538462,
        'lower-right': 69.230769,
        'half-blink': 76.923077,
        blink: 84.615385
      };
      this.offsets = {
        neutral: [0, 0],
        'cross-eyed': [0, 0],
        left: [-4, -1],
        right: [-14, -1],
        up: [0, 0],
        down: [-1, 1],
        'upper-left': [1, -1],
        'upper-right': [-19, -1],
        'lower-left': [-3, 0],
        'lower-right': [-15, 0],
        'half-blink': [0, 0],
        blink: [0, 0]
      };
      this.currentFrame = 'neutral';
      this.pendingFrame = 'neutral';
      this.pointerFrame = null;
      this.pendingTimeout = null;
      this.blinkTimeout = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onMotionChange = this.onMotionChange.bind(this);
      this.motionQuery.addEventListener('change', this.onMotionChange);
      this.resizeObserver = new ResizeObserver(() => this.applyOffset(this.currentFrame));
      this.resizeObserver.observe(this);
      this.onMotionChange();
    }

    disconnectedCallback() {
      this.disable();
      this.motionQuery.removeEventListener('change', this.onMotionChange);
      this.resizeObserver.disconnect();
    }

    onMotionChange() {
      if (this.motionQuery.matches) {
        this.enable();
        this.scheduleBlink();
        if (window.gfCursorPoint) this.updateFromPoint(window.gfCursorPoint.x, window.gfCursorPoint.y);
      } else {
        this.disable();
        this.showFrame('neutral');
      }
    }

    enable() {
      if (this.tracking) return;
      this.tracking = true;
      window.addEventListener('pointermove', this.onPointerMove, { passive: true });
    }

    disable() {
      if (!this.tracking) return;
      this.tracking = false;
      window.removeEventListener('pointermove', this.onPointerMove);
      window.cancelAnimationFrame(this.pointerFrame);
      window.clearTimeout(this.pendingTimeout);
      window.clearTimeout(this.blinkTimeout);
    }

    onPointerMove(event) {
      if (event.pointerType === 'touch') return;
      this.lastPoint = { x: event.clientX, y: event.clientY };
      window.clearTimeout(this.blinkTimeout);
      if (this.pointerFrame) return;
      this.pointerFrame = window.requestAnimationFrame(() => {
        this.pointerFrame = null;
        this.updateFromPoint(this.lastPoint.x, this.lastPoint.y);
      });
    }

    updateFromPoint(clientX, clientY) {
      const rect = this.getBoundingClientRect();
      const horizontal = (clientX - (rect.left + rect.width / 2)) / Math.max(1, rect.width / 2);
      const vertical = (clientY - (rect.top + rect.height * 0.48)) / Math.max(1, rect.height / 2);
      const centered = Math.hypot(horizontal, vertical) <= 0.198;
      let nextFrame = 'cross-eyed';
      if (!centered) {
        if (vertical > 0.38 && Math.abs(vertical) > Math.abs(horizontal) * 0.52) {
          if (horizontal > 0.38) nextFrame = 'lower-right';
          else if (horizontal < -0.38) nextFrame = 'lower-left';
          else nextFrame = 'down';
        } else if (vertical < -0.34 && Math.abs(vertical) > Math.abs(horizontal) * 0.58) {
          if (horizontal > 0.42) nextFrame = 'upper-right';
          else if (horizontal < -0.42) nextFrame = 'upper-left';
          else nextFrame = 'up';
        } else {
          nextFrame = horizontal < 0 ? 'left' : 'right';
        }
      }
      this.queueFrame(nextFrame);
    }

    queueFrame(nextFrame) {
      if (nextFrame === this.pendingFrame) return;
      this.pendingFrame = nextFrame;
      window.clearTimeout(this.pendingTimeout);
      this.pendingTimeout = window.setTimeout(() => {
        this.showFrame(this.pendingFrame);
        this.scheduleBlink();
      }, 55);
    }

    showFrame(name) {
      if (this.frames[name] == null) return;
      this.currentFrame = name;
      this.style.backgroundPosition = `${this.frames[name]}% 0`;
      this.applyOffset(name);
    }

    applyOffset(name) {
      const offset = this.offsets[name] || this.offsets.neutral;
      const scale = this.clientWidth / 418;
      this.style.setProperty('--gf-dog-frame-x', `${Math.round(offset[0] * scale)}px`);
      this.style.setProperty('--gf-dog-frame-y', `${Math.round(offset[1] * scale)}px`);
    }

    scheduleBlink() {
      window.clearTimeout(this.blinkTimeout);
      if (this.currentFrame !== 'neutral' && this.currentFrame !== 'cross-eyed') return;
      this.blinkTimeout = window.setTimeout(() => this.playBlink(), 3600 + Math.random() * 3600);
    }

    playBlink() {
      const returnFrame = this.currentFrame;
      this.showFrame('half-blink');
      window.setTimeout(() => this.showFrame('blink'), 90);
      window.setTimeout(() => this.showFrame('half-blink'), 190);
      window.setTimeout(() => {
        this.showFrame(returnFrame);
        this.scheduleBlink();
      }, 280);
    }
  }

  if (!customElements.get('gf-password-cursor-dog')) {
    customElements.define('gf-password-cursor-dog', GfPasswordCursorDog);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newslwtter"] && !Shopify.designMode) return;
  try {
    
  class GfCursorDog extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.visual = this.closest('[data-gf-dog-visual]') || this.closest('.gf-face-club__visual');
      this.lostAutoplay = this.hasAttribute('data-lost-autoplay');
      this.frameCount = Number.parseInt(this.dataset.frameCount || '14', 10);
      this.hasPersonalityFrames = this.frameCount >= 20;
      this.lostSequence = [
        { frame: 'left', min: 1050, max: 1650 },
        { frame: 'right', min: 280, max: 480 },
        { frame: 'left', min: 520, max: 820 },
        { frame: 'neutral', min: 1700, max: 2800 },
        { frame: 'upper-left', min: 850, max: 1350 },
        { frame: 'lower-right', min: 350, max: 650 },
        { frame: 'down', min: 1250, max: 2000 },
        { frame: 'half-blink', min: 70, max: 95 },
        { frame: 'blink', min: 90, max: 130 },
        { frame: 'half-blink', min: 70, max: 100 },
        { frame: 'neutral', min: 2200, max: 3600 },
        { frame: 'upper-right', min: 620, max: 1000 },
        { frame: 'lower-left', min: 950, max: 1500 },
        { frame: 'up', min: 1200, max: 1900 },
        { frame: 'neutral', min: 2600, max: 4200 }
      ];
      this.lostFrameIndex = -1;
      this.lostTimer = null;
      this.pointerInsideVisual = false;
      const framePosition = (index) => (index / Math.max(1, this.frameCount - 1)) * 100;
      this.framePositions = {
        neutral: framePosition(0),
        'cross-eyed': framePosition(1),
        left: framePosition(2),
        right: framePosition(3),
        up: framePosition(4),
        down: framePosition(5),
        'upper-left': framePosition(6),
        'upper-right': framePosition(7),
        'lower-left': framePosition(8),
        'lower-right': framePosition(9),
        'half-blink': framePosition(10),
        blink: framePosition(11),
        'lick-tip': framePosition(12),
        'lick-full': framePosition(13),
        'tilt-left': framePosition(14),
        'tilt-right': framePosition(15),
        'sniff-soft': framePosition(16),
        'sniff-peak': framePosition(17),
        'yawn-start': framePosition(18),
        'yawn-full': framePosition(19)
      };
      this.frameOffsets = {
        neutral: { x: 0, y: 0 },
        'cross-eyed': { x: 0, y: 0 },
        left: { x: -4, y: -1 },
        right: { x: -14, y: -1 },
        up: { x: 0, y: 0 },
        down: { x: -1, y: 1 },
        'upper-left': { x: 1, y: -1 },
        'upper-right': { x: -19, y: -1 },
        'lower-left': { x: -3, y: 0 },
        'lower-right': { x: -15, y: 0 },
        'half-blink': { x: 0, y: 0 },
        blink: { x: 0, y: 0 },
        'lick-tip': { x: 0, y: 0 },
        'lick-full': { x: 0, y: 0 },
        'tilt-left': { x: 0, y: 0 },
        'tilt-right': { x: 0, y: 0 },
        'sniff-soft': { x: 0, y: 0 },
        'sniff-peak': { x: 0, y: 0 },
        'yawn-start': { x: 0, y: 0 },
        'yawn-full': { x: 0, y: 0 }
      };
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');
      this.currentFrame = 'neutral';
      this.gazeFrame = 'neutral';
      this.pendingFrame = 'neutral';
      this.pendingGazeTimeout = null;
      this.pointerFrame = null;
      this.lastPointer = null;
      this.lastPointerAt = performance.now();
      this.lastInputType = 'mouse';
      this.ignoreMouseUntil = 0;
      this.touchIdentifier = null;
      this.touchStartPoint = null;
      this.touchMoved = false;
      this.touchActive = false;
      this.touchReturnTimeout = null;
      this.blinking = false;
      this.blinkTimeout = null;
      this.blinkSteps = [];
      this.lickHovering = false;
      this.lickHoverTimeout = null;
      this.licking = false;
      this.lickSteps = [];
      this.personalityTimeout = null;
      this.personalitySteps = [];
      this.personalityActive = false;
      this.personalityOrder = ['tilt', 'double-blink', 'sniff', 'tongue-peek', 'tilt', 'yawn'];
      this.personalityIndex = Math.floor(Math.random() * this.personalityOrder.length);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.onTouchCancel = this.onTouchCancel.bind(this);
      this.updateGaze = this.updateGaze.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.onMotionChange = this.onMotionChange.bind(this);
      this.motionQuery.addEventListener('change', this.onMotionChange);
      this.visibilityObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        if (this.lostAutoplay) this.scheduleLostLook(250);
        else this.primePointer();
      }, { threshold: 0.05 });
      this.visibilityObserver.observe(this);
      this.resizeObserver = new ResizeObserver(() => this.applyFrameOffset(this.currentFrame));
      this.resizeObserver.observe(this);
      this.onMotionChange();
    }

    disconnectedCallback() {
      this.disableTracking();
      this.clearBlinkTimers();
      this.clearLickTimers();
      this.clearTouchReturn();
      this.clearLostLook();
      this.clearPersonalityTimers();
      window.clearTimeout(this.pendingGazeTimeout);
      window.cancelAnimationFrame(this.pointerFrame);
      this.motionQuery?.removeEventListener('change', this.onMotionChange);
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }

    onMotionChange() {
      if (this.motionQuery.matches) {
        this.enableTracking();
        if (this.lostAutoplay) this.scheduleLostLook(250);
        else this.primePointer();
        this.scheduleBlink();
        this.schedulePersonality();
      } else {
        this.disableTracking();
        this.clearBlinkTimers();
        this.clearLickTimers();
        this.clearLostLook();
        this.clearPersonalityTimers();
        this.gazeFrame = 'neutral';
        this.showFrame('neutral');
      }
    }

    enableTracking() {
      if (this.tracking) return;
      this.tracking = true;
      window.addEventListener('pointermove', this.onPointerMove, { passive: true });
      window.addEventListener('touchstart', this.onTouchStart, { passive: true });
      window.addEventListener('touchmove', this.onTouchMove, { passive: true });
      window.addEventListener('touchend', this.onTouchEnd, { passive: true });
      window.addEventListener('touchcancel', this.onTouchCancel, { passive: true });
      document.documentElement.addEventListener('mouseleave', this.onPointerLeave);
      window.addEventListener('blur', this.onPointerLeave);
    }

    disableTracking() {
      if (!this.tracking) return;
      this.tracking = false;
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('touchstart', this.onTouchStart);
      window.removeEventListener('touchmove', this.onTouchMove);
      window.removeEventListener('touchend', this.onTouchEnd);
      window.removeEventListener('touchcancel', this.onTouchCancel);
      document.documentElement.removeEventListener('mouseleave', this.onPointerLeave);
      window.removeEventListener('blur', this.onPointerLeave);
      window.cancelAnimationFrame(this.pointerFrame);
      window.clearTimeout(this.pendingGazeTimeout);
      this.clearTouchReturn();
      this.clearLostLook();
      this.cancelLickHover();
      this.clearPersonalityTimers();
      this.pointerFrame = null;
      this.pendingGazeTimeout = null;
    }

    primePointer() {
      if (!this.motionQuery?.matches) return;
      const point = window.gfCursorPoint;
      if (!point || !Number.isFinite(point.x) || !Number.isFinite(point.y)) return;
      this.lastPointer = {
        x: Math.min(window.innerWidth, Math.max(0, point.x)),
        y: Math.min(window.innerHeight, Math.max(0, point.y))
      };
      this.lastPointerAt = performance.now();
      window.cancelAnimationFrame(this.pointerFrame);
      this.pointerFrame = window.requestAnimationFrame(this.updateGaze);
    }

    onPointerMove(event) {
      if (!this.visual) return;
      if (event.pointerType === 'touch') return;
      if (performance.now() < this.ignoreMouseUntil) return;
      this.lastInputType = 'mouse';
      this.touchActive = false;
      this.clearTouchReturn();
      const wasBlinking = this.blinking;
      const wasPersonalityActive = this.personalityActive;
      this.clearBlinkTimers();
      this.clearPersonalityTimers();
      if (wasBlinking) this.showFrame(this.gazeFrame);
      if (wasPersonalityActive) this.showFrame(this.gazeFrame);
      const visualRect = this.visual.getBoundingClientRect();
      this.pointerInsideVisual = event.clientX >= visualRect.left
        && event.clientX <= visualRect.right
        && event.clientY >= visualRect.top
        && event.clientY <= visualRect.bottom;
      if (this.lostAutoplay && !this.pointerInsideVisual) {
        this.lastPointer = null;
        this.cancelLickHover();
        this.scheduleLostLook(260);
        return;
      }
      this.clearLostLook();
      this.lastPointer = { x: event.clientX, y: event.clientY };
      this.lastPointerAt = performance.now();
      this.schedulePersonality();
      if (this.pointerFrame) return;
      this.pointerFrame = window.requestAnimationFrame(this.updateGaze);
    }

    onTouchStart(event) {
      if (!this.visual || this.touchIdentifier != null || event.touches.length !== 1) return;
      const touch = event.touches[0];
      this.lastInputType = 'touch';
      this.touchIdentifier = touch.identifier;
      this.touchStartPoint = { x: touch.clientX, y: touch.clientY, at: performance.now() };
      this.touchMoved = false;
      this.touchActive = true;
      this.pointerInsideVisual = true;
      this.clearLostLook();
      this.cancelLickHover();
      this.clearTouchReturn();
      this.clearPersonalityTimers(true);
      this.updateTouchPoint(touch);
    }

    onTouchMove(event) {
      const touch = this.getTrackedTouch(event.touches);
      if (!touch || !this.touchStartPoint) return;
      const movement = Math.hypot(touch.clientX - this.touchStartPoint.x, touch.clientY - this.touchStartPoint.y);
      if (movement > 12) this.touchMoved = true;
      this.updateTouchPoint(touch);
    }

    onTouchEnd(event) {
      const touch = this.getTrackedTouch(event.changedTouches);
      if (!touch || !this.touchStartPoint) return;
      const duration = performance.now() - this.touchStartPoint.at;
      const movement = Math.hypot(touch.clientX - this.touchStartPoint.x, touch.clientY - this.touchStartPoint.y);
      const deliberateTap = !this.touchMoved && movement <= 12 && duration <= 350;
      const tappedNose = deliberateTap && this.isNosePoint(touch.clientX, touch.clientY);
      this.touchActive = false;
      this.ignoreMouseUntil = performance.now() + 700;
      this.touchIdentifier = null;
      this.touchStartPoint = null;
      this.touchMoved = false;
      if (tappedNose) {
        window.cancelAnimationFrame(this.pointerFrame);
        this.pointerFrame = null;
        this.clearBlinkTimers();
        this.cancelLickHover();
        window.clearTimeout(this.pendingGazeTimeout);
        this.pendingGazeTimeout = null;
        this.gazeFrame = 'cross-eyed';
        this.pendingFrame = 'cross-eyed';
        if (!this.licking) this.showFrame('cross-eyed');
        this.playLick(false);
        this.scheduleTouchReturn(1100);
      } else {
        this.updateTouchPoint(touch);
        this.scheduleTouchReturn(900);
      }
    }

    onTouchCancel() {
      this.touchActive = false;
      this.touchIdentifier = null;
      this.touchStartPoint = null;
      this.touchMoved = false;
      this.ignoreMouseUntil = performance.now() + 700;
      this.scheduleTouchReturn(250);
    }

    getTrackedTouch(touches) {
      if (this.touchIdentifier == null) return null;
      for (let index = 0; index < touches.length; index += 1) {
        if (touches[index].identifier === this.touchIdentifier) return touches[index];
      }
      return null;
    }

    updateTouchPoint(touch) {
      const wasBlinking = this.blinking;
      const wasPersonalityActive = this.personalityActive;
      this.clearBlinkTimers();
      this.clearPersonalityTimers();
      if (wasBlinking) this.showFrame(this.gazeFrame);
      if (wasPersonalityActive) this.showFrame(this.gazeFrame);
      this.lastPointer = { x: touch.clientX, y: touch.clientY };
      this.lastPointerAt = performance.now();
      if (this.pointerFrame) return;
      this.pointerFrame = window.requestAnimationFrame(this.updateGaze);
    }

    isNosePoint(clientX, clientY) {
      const dogRect = this.getBoundingClientRect();
      const noseX = dogRect.left + dogRect.width * 0.49;
      const noseY = dogRect.top + dogRect.height * 0.575;
      const horizontal = (clientX - noseX) / Math.max(1, dogRect.width / 2);
      const vertical = (clientY - noseY) / Math.max(1, dogRect.height / 2);
      return Math.hypot(horizontal, vertical) <= 0.242;
    }

    scheduleTouchReturn(delay) {
      this.clearTouchReturn();
      this.touchReturnTimeout = window.setTimeout(() => {
        this.touchReturnTimeout = null;
        if (this.touchActive || this.lastInputType !== 'touch') return;
        if (this.licking) {
          this.scheduleTouchReturn(200);
          return;
        }
        this.gazeFrame = 'neutral';
        this.pendingFrame = 'neutral';
        this.lastPointer = null;
        this.showFrame('neutral');
        this.pointerInsideVisual = false;
        if (this.lostAutoplay) this.scheduleLostLook(350);
        else this.scheduleBlink();
        this.schedulePersonality();
      }, delay);
    }

    clearTouchReturn() {
      window.clearTimeout(this.touchReturnTimeout);
      this.touchReturnTimeout = null;
    }

    updateGaze() {
      this.pointerFrame = null;
      if (!this.visual || !this.lastPointer) return;
      const visualRect = this.visual.getBoundingClientRect();
      if (visualRect.bottom < 0 || visualRect.top > window.innerHeight) {
        this.cancelLickHover();
        return;
      }
      const dogRect = this.getBoundingClientRect();
      const centerX = dogRect.left + dogRect.width / 2;
      const centerY = dogRect.top + dogRect.height * 0.48;
      const horizontal = (this.lastPointer.x - centerX) / Math.max(1, dogRect.width / 2);
      const vertical = (this.lastPointer.y - centerY) / Math.max(1, dogRect.height / 2);
      const distance = Math.hypot(horizontal, vertical);
      const crossEyeHovering = distance <= 0.198;
      if (this.lastInputType === 'mouse') this.updateLickHover(crossEyeHovering);
      else this.cancelLickHover();
      let nextFrame = 'cross-eyed';
      if (!crossEyeHovering) {
        if (vertical > 0.38 && Math.abs(vertical) > Math.abs(horizontal) * 0.52) {
          if (horizontal > 0.38) nextFrame = 'lower-right';
          else if (horizontal < -0.38) nextFrame = 'lower-left';
          else nextFrame = 'down';
        } else if (vertical < -0.34 && Math.abs(vertical) > Math.abs(horizontal) * 0.58) {
          if (horizontal > 0.42) nextFrame = 'upper-right';
          else if (horizontal < -0.42) nextFrame = 'upper-left';
          else nextFrame = 'up';
        } else {
          nextFrame = horizontal < 0 ? 'left' : 'right';
        }
      }
      this.queueGazeFrame(nextFrame);
    }

    queueGazeFrame(nextFrame) {
      if (nextFrame === this.gazeFrame) {
        this.pendingFrame = nextFrame;
        window.clearTimeout(this.pendingGazeTimeout);
        this.pendingGazeTimeout = null;
        this.scheduleBlink();
        this.schedulePersonality();
        return;
      }
      if (nextFrame === this.pendingFrame) return;
      this.pendingFrame = nextFrame;
      window.clearTimeout(this.pendingGazeTimeout);
      this.pendingGazeTimeout = window.setTimeout(() => {
        this.gazeFrame = this.pendingFrame;
        this.pendingGazeTimeout = null;
        if (!this.blinking && !this.licking) this.showFrame(this.gazeFrame);
        this.scheduleBlink();
        this.schedulePersonality();
      }, 55);
    }

    onPointerLeave() {
      if (this.touchActive) return;
      this.clearBlinkTimers();
      this.clearLickTimers();
      this.clearTouchReturn();
      this.clearPersonalityTimers();
      this.gazeFrame = 'neutral';
      this.pendingFrame = 'neutral';
      this.lastPointer = null;
      this.lastPointerAt = performance.now();
      window.clearTimeout(this.pendingGazeTimeout);
      this.pendingGazeTimeout = null;
      this.blinking = false;
      this.showFrame('neutral');
      this.pointerInsideVisual = false;
      if (this.lostAutoplay) this.scheduleLostLook(250);
      else this.scheduleBlink();
      this.schedulePersonality();
    }

    scheduleLostLook(delay = 900) {
      if (!this.lostAutoplay || !this.motionQuery?.matches || this.lostTimer || this.touchActive || this.pointerInsideVisual) return;
      this.lostTimer = window.setTimeout(() => {
        this.lostTimer = null;
        if (this.touchActive || this.pointerInsideVisual || this.licking) {
          this.scheduleLostLook(500);
          return;
        }
        this.clearBlinkTimers();
        this.lostFrameIndex = (this.lostFrameIndex + 1) % this.lostSequence.length;
        const step = this.lostSequence[this.lostFrameIndex];
        const nextFrame = step.frame;
        this.gazeFrame = nextFrame;
        this.pendingFrame = nextFrame;
        this.lastPointer = null;
        this.showFrame(nextFrame);
        this.scheduleLostLook(step.min + Math.random() * (step.max - step.min));
      }, delay);
    }

    clearLostLook() {
      window.clearTimeout(this.lostTimer);
      this.lostTimer = null;
    }

    updateLickHover(lickHovering) {
      if (!lickHovering) {
        this.cancelLickHover();
        return;
      }
      this.lickHovering = true;
      this.scheduleLick();
    }

    scheduleLick() {
      if (!this.motionQuery.matches || !this.lickHovering || this.lickHoverTimeout) return;
      const delay = 1000 + Math.random() * 1000;
      this.lickHoverTimeout = window.setTimeout(() => {
        this.lickHoverTimeout = null;
        if (this.lickHovering) this.playLick();
      }, delay);
    }

    cancelLickHover() {
      this.lickHovering = false;
      window.clearTimeout(this.lickHoverTimeout);
      this.lickHoverTimeout = null;
    }

    playLick(repeat = true) {
      if (!this.motionQuery.matches || this.licking) return;
      if (repeat && !this.lickHovering) return;
      this.clearBlinkTimers();
      this.clearPersonalityTimers();
      this.lickSteps.forEach((timer) => window.clearTimeout(timer));
      this.lickSteps = [];
      this.licking = true;
      if (repeat) this.scheduleLick();
      this.showFrame('lick-tip');
      this.lickSteps.push(window.setTimeout(() => this.showFrame('lick-full'), 90));
      this.lickSteps.push(window.setTimeout(() => this.showFrame('lick-tip'), 245));
      this.lickSteps.push(window.setTimeout(() => {
        this.licking = false;
        this.showFrame(this.gazeFrame);
        this.lickSteps = [];
        this.scheduleBlink();
        this.schedulePersonality();
      }, 350));
    }

    showFrame(name) {
      if (this.framePositions[name] == null) return;
      this.applyFrameOffset(name);
      if (name === this.currentFrame) return;
      this.style.backgroundPosition = `${this.framePositions[name]}% 0`;
      this.currentFrame = name;
    }

    applyFrameOffset(name) {
      const sourceOffset = this.frameOffsets[name] || this.frameOffsets.neutral;
      const displayScale = this.clientWidth / 418;
      this.style.setProperty('--gf-dog-frame-x', `${Math.round(sourceOffset.x * displayScale)}px`);
      this.style.setProperty('--gf-dog-frame-y', `${Math.round(sourceOffset.y * displayScale)}px`);
    }

    scheduleBlink() {
      if (!this.motionQuery.matches) return;
      window.clearTimeout(this.blinkTimeout);
      this.blinkTimeout = null;
      if (this.licking || this.lickHovering || this.personalityActive) return;
      if (this.gazeFrame !== 'neutral' && this.gazeFrame !== 'cross-eyed') return;
      this.blinkTimeout = window.setTimeout(() => this.playBlink(), 3600 + Math.random() * 3600);
    }

    playBlink() {
      if (!this.motionQuery.matches || this.blinking || this.licking || this.personalityActive) return;
      if (this.gazeFrame !== 'neutral' && this.gazeFrame !== 'cross-eyed') return;
      if (this.lastPointer && performance.now() - this.lastPointerAt < 900) {
        this.scheduleBlink();
        return;
      }
      this.blinking = true;
      this.showFrame('half-blink');
      this.blinkSteps.push(window.setTimeout(() => this.showFrame('blink'), 75));
      this.blinkSteps.push(window.setTimeout(() => this.showFrame('half-blink'), 155));
      this.blinkSteps.push(window.setTimeout(() => {
        this.blinking = false;
        this.showFrame(this.gazeFrame);
        this.blinkSteps = [];
        this.scheduleBlink();
        this.schedulePersonality();
      }, 235));
    }

    schedulePersonality(delay = 6500 + Math.random() * 6500) {
      if (!this.hasPersonalityFrames || this.lostAutoplay || !this.motionQuery?.matches) return;
      if (this.personalityTimeout || this.personalityActive || this.licking || this.lickHovering || this.touchActive) return;
      this.personalityTimeout = window.setTimeout(() => this.playPersonality(), delay);
    }

    playPersonality() {
      this.personalityTimeout = null;
      if (!this.motionQuery.matches || this.personalityActive || this.licking || this.lickHovering || this.touchActive) {
        this.schedulePersonality();
        return;
      }
      if (this.lastPointer && performance.now() - this.lastPointerAt < 3000) {
        this.schedulePersonality(3500);
        return;
      }

      const action = this.personalityOrder[this.personalityIndex % this.personalityOrder.length];
      this.personalityIndex += 1;
      this.clearBlinkTimers();
      this.personalityActive = true;
      this.showFrame('neutral');

      const showLater = (frame, delay) => {
        this.personalitySteps.push(window.setTimeout(() => this.showFrame(frame), delay));
      };
      const finishLater = (delay) => {
        this.personalitySteps.push(window.setTimeout(() => {
          this.personalityActive = false;
          this.showFrame(this.gazeFrame);
          this.personalitySteps = [];
          this.scheduleBlink();
          this.schedulePersonality();
        }, delay));
      };

      if (action === 'tilt') {
        showLater('tilt-left', 120);
        showLater('neutral', 560);
        showLater('tilt-right', 720);
        showLater('neutral', 1160);
        finishLater(1300);
      } else if (action === 'double-blink') {
        showLater('half-blink', 100);
        showLater('blink', 175);
        showLater('half-blink', 255);
        showLater('neutral', 330);
        showLater('half-blink', 455);
        showLater('blink', 530);
        showLater('half-blink', 610);
        showLater('neutral', 685);
        finishLater(800);
      } else if (action === 'sniff') {
        showLater('sniff-soft', 100);
        showLater('sniff-peak', 300);
        showLater('sniff-soft', 510);
        showLater('neutral', 710);
        finishLater(830);
      } else if (action === 'tongue-peek') {
        showLater('cross-eyed', 100);
        showLater('lick-tip', 260);
        showLater('cross-eyed', 500);
        showLater('neutral', 670);
        finishLater(790);
      } else {
        showLater('yawn-start', 120);
        showLater('yawn-full', 390);
        showLater('yawn-start', 940);
        showLater('neutral', 1190);
        finishLater(1320);
      }
    }

    clearPersonalityTimers(restoreFrame = false) {
      window.clearTimeout(this.personalityTimeout);
      this.personalityTimeout = null;
      this.personalitySteps.forEach((timer) => window.clearTimeout(timer));
      this.personalitySteps = [];
      const wasActive = this.personalityActive;
      this.personalityActive = false;
      if (restoreFrame && wasActive && !this.licking) this.showFrame(this.gazeFrame);
    }

    clearBlinkTimers() {
      window.clearTimeout(this.blinkTimeout);
      this.blinkTimeout = null;
      this.blinkSteps.forEach((timer) => window.clearTimeout(timer));
      this.blinkSteps = [];
      this.blinking = false;
    }

    clearLickTimers() {
      this.cancelLickHover();
      this.lickSteps.forEach((timer) => window.clearTimeout(timer));
      this.lickSteps = [];
      this.licking = false;
    }
  }

  if (!customElements.get('gf-cursor-dog')) customElements.define('gf-cursor-dog', GfCursorDog);

  } catch(e) { console.error(e); }
})();
})();
